
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree419"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree419"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kCTg6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Fragment = module.exports.jsxDEV = module.exports.jsxs = void 0;
module.exports.jsx = $f0423878b29dd23a$var$jsx;

var $ceFTv = parcelRequire("ceFTv");

var $hsoqa = parcelRequire("hsoqa");

var $9V3mG = parcelRequire("9V3mG");
/**
 * @see {@link https://github.com/reactjs/rfcs/blob/createlement-rfc/text/0000-create-element-changes.md}
 * @see {@link https://babeljs.io/docs/babel-plugin-transform-react-jsx}
 */ function $f0423878b29dd23a$var$jsx(type, _a, key) {
    var ref = _a.ref, is = _a.is, style = _a.style, children = _a.children, props = $ceFTv.__rest(_a, [
        "ref",
        "is",
        "style",
        "children"
    ]);
    if (typeof type === 'function' && (0, $hsoqa.isHTMLElementClass)(type)) type = (0, $hsoqa.tagNameOf)(type);
    children = [
        children
    ].flat(Infinity).map(function(node) {
        return node instanceof Object ? new $9V3mG.VNode(node) : node === 0 || node ? new $9V3mG.VNode({
            text: node.toString()
        }) : undefined;
    }).filter(Boolean);
    var commonProps = {
        key: key,
        ref: ref,
        is: is,
        style: style,
        children: children
    };
    return typeof type === 'string' ? new $9V3mG.VNode($ceFTv.__assign($ceFTv.__assign({}, commonProps), {
        tagName: type,
        props: props
    })) : type($ceFTv.__assign($ceFTv.__assign({}, commonProps), props));
}
module.exports.jsxs = $f0423878b29dd23a$var$jsx;
module.exports.jsxDEV = $f0423878b29dd23a$var$jsx;
/**
 * @see {@link https://babeljs.io/docs/babel-plugin-transform-react-jsx#react-automatic-runtime-1}
 */ var $f0423878b29dd23a$var$Fragment = function(_a) {
    var key = _a.key, ref = _a.ref, is = _a.is, style = _a.style, children = _a.children, props = $ceFTv.__rest(_a, [
        "key",
        "ref",
        "is",
        "style",
        "children"
    ]);
    return new $9V3mG.VNode({
        key: key,
        ref: ref,
        is: is,
        props: (0, $hsoqa.isEmpty)(props) ? undefined : props,
        style: style,
        children: children
    });
};
module.exports.Fragment = $f0423878b29dd23a$var$Fragment;

});
parcelRegister("ceFTv", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $8e874a2fb001c377$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $8e874a2fb001c377$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $8e874a2fb001c377$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $8e874a2fb001c377$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $8e874a2fb001c377$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $8e874a2fb001c377$export$f33643c0debef087);
$parcel$export(module.exports, "__values", () => $8e874a2fb001c377$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $8e874a2fb001c377$export$8d051b38c9118094);
$parcel$export(module.exports, "__spreadArray", () => $8e874a2fb001c377$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $8e874a2fb001c377$var$extendStatics = function(d, b) {
    $8e874a2fb001c377$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $8e874a2fb001c377$var$extendStatics(d, b);
};
function $8e874a2fb001c377$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $8e874a2fb001c377$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $8e874a2fb001c377$export$18ce0697a983be9b = function() {
    $8e874a2fb001c377$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8e874a2fb001c377$export$18ce0697a983be9b.apply(this, arguments);
};
function $8e874a2fb001c377$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $8e874a2fb001c377$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $8e874a2fb001c377$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $8e874a2fb001c377$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $8e874a2fb001c377$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $8e874a2fb001c377$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $8e874a2fb001c377$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $8e874a2fb001c377$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $8e874a2fb001c377$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $8e874a2fb001c377$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $8e874a2fb001c377$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $8e874a2fb001c377$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $8e874a2fb001c377$export$45d3717a4c69092e(o, m, p);
}
function $8e874a2fb001c377$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $8e874a2fb001c377$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $8e874a2fb001c377$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($8e874a2fb001c377$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $8e874a2fb001c377$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $8e874a2fb001c377$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $8e874a2fb001c377$export$10c90e4f7922046c(v) {
    return this instanceof $8e874a2fb001c377$export$10c90e4f7922046c ? (this.v = v, this) : new $8e874a2fb001c377$export$10c90e4f7922046c(v);
}
function $8e874a2fb001c377$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $8e874a2fb001c377$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $8e874a2fb001c377$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $8e874a2fb001c377$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $8e874a2fb001c377$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $8e874a2fb001c377$export$19a8beecd37a4c45 === "function" ? $8e874a2fb001c377$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $8e874a2fb001c377$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $8e874a2fb001c377$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $8e874a2fb001c377$var$ownKeys = function(o) {
    $8e874a2fb001c377$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $8e874a2fb001c377$var$ownKeys(o);
};
function $8e874a2fb001c377$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $8e874a2fb001c377$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $8e874a2fb001c377$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $8e874a2fb001c377$var$__setModuleDefault(result, mod);
    return result;
}
function $8e874a2fb001c377$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $8e874a2fb001c377$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $8e874a2fb001c377$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $8e874a2fb001c377$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $8e874a2fb001c377$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $8e874a2fb001c377$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $8e874a2fb001c377$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $8e874a2fb001c377$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $8e874a2fb001c377$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $8e874a2fb001c377$export$2e2bcd8739ae039 = {
    __extends: $8e874a2fb001c377$export$a8ba968b8961cb8a,
    __assign: $8e874a2fb001c377$export$18ce0697a983be9b,
    __rest: $8e874a2fb001c377$export$3c9a16f847548506,
    __decorate: $8e874a2fb001c377$export$29e00dfd3077644b,
    __param: $8e874a2fb001c377$export$d5ad3fd78186038f,
    __esDecorate: $8e874a2fb001c377$export$3a84e1ae4e97e9b0,
    __runInitializers: $8e874a2fb001c377$export$d831c04e792af3d,
    __propKey: $8e874a2fb001c377$export$6a2a36740a146cb8,
    __setFunctionName: $8e874a2fb001c377$export$d1a06452d3489bc7,
    __metadata: $8e874a2fb001c377$export$f1db080c865becb9,
    __awaiter: $8e874a2fb001c377$export$1050f835b63b671e,
    __generator: $8e874a2fb001c377$export$67ebef60e6f28a6,
    __createBinding: $8e874a2fb001c377$export$45d3717a4c69092e,
    __exportStar: $8e874a2fb001c377$export$f33643c0debef087,
    __values: $8e874a2fb001c377$export$19a8beecd37a4c45,
    __read: $8e874a2fb001c377$export$8d051b38c9118094,
    __spread: $8e874a2fb001c377$export$afc72e2116322959,
    __spreadArrays: $8e874a2fb001c377$export$6388937ca91ccae8,
    __spreadArray: $8e874a2fb001c377$export$1216008129fb82ed,
    __await: $8e874a2fb001c377$export$10c90e4f7922046c,
    __asyncGenerator: $8e874a2fb001c377$export$e427f37a30a4de9b,
    __asyncDelegator: $8e874a2fb001c377$export$bbd80228419bb833,
    __asyncValues: $8e874a2fb001c377$export$e3b29a3d6162315f,
    __makeTemplateObject: $8e874a2fb001c377$export$4fb47efe1390b86f,
    __importStar: $8e874a2fb001c377$export$c21735bcef00d192,
    __importDefault: $8e874a2fb001c377$export$da59b14a69baef04,
    __classPrivateFieldGet: $8e874a2fb001c377$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $8e874a2fb001c377$export$d40a35129aaff81f,
    __classPrivateFieldIn: $8e874a2fb001c377$export$81fdc39f203e4e04,
    __addDisposableResource: $8e874a2fb001c377$export$88ac25d8e944e405,
    __disposeResources: $8e874a2fb001c377$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $8e874a2fb001c377$export$889dfb5d17574b0b
};

});

parcelRegister("hsoqa", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $cb57feaff75246de$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "toHyphenCase", () => $cb57feaff75246de$export$3f34ca2fef821bbd);
$parcel$export(module.exports, "toCamelCase", () => $cb57feaff75246de$export$86f54f62aa7a7514);
$parcel$export(module.exports, "DiffStatus", () => $cb57feaff75246de$export$2ddabb89308e1a22);
$parcel$export(module.exports, "diffKeys", () => $cb57feaff75246de$export$14527669107aa301);
$parcel$export(module.exports, "groupBy", () => $cb57feaff75246de$export$3f063810d7bf01bd);
$parcel$export(module.exports, "parseJSON", () => $cb57feaff75246de$export$27924e57e9afff7f);
$parcel$export(module.exports, "isXDomain", () => $cb57feaff75246de$export$71e6483fc2b024eb);
$parcel$export(module.exports, "parseURLData", () => $cb57feaff75246de$export$eb9b2aadbe449a20);
$parcel$export(module.exports, "buildURLData", () => $cb57feaff75246de$export$13397a83aa5915d6);
$parcel$export(module.exports, "XMLNamespace", () => $cb57feaff75246de$export$f5a4056b78c72efa);
$parcel$export(module.exports, "templateOf", () => $cb57feaff75246de$export$2ee022bbbc550b25);
$parcel$export(module.exports, "elementTypeOf", () => $cb57feaff75246de$export$a549dd5cef7f8327);
$parcel$export(module.exports, "isHTMLElementClass", () => $cb57feaff75246de$export$8eece510bcb9c62c);
$parcel$export(module.exports, "tagNameOf", () => $cb57feaff75246de$export$b8a1af58c024fefd);
$parcel$export(module.exports, "getVisibleText", () => $cb57feaff75246de$export$be4650432daa84fd);
$parcel$export(module.exports, "importCSS", () => $cb57feaff75246de$export$7cd14c57bbb84350);
$parcel$export(module.exports, "scrollTo", () => $cb57feaff75246de$export$3f99968195accfaf);
$parcel$export(module.exports, "formToJSON", () => $cb57feaff75246de$export$86d7c59254d6a2c9);
$parcel$export(module.exports, "sleep", () => $cb57feaff75246de$export$e772c8ff12451969);
$parcel$export(module.exports, "delegate", () => $cb57feaff75246de$export$10b1921597150314);
$parcel$export(module.exports, "documentReady", () => $cb57feaff75246de$export$3e2b244719956741);
function $cb57feaff75246de$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $cb57feaff75246de$var$$9b05bcda60cc529c$exports = {};
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "likeNull", function() {
    return $cb57feaff75246de$export$61cc6ed0f143570b;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "isEmpty", function() {
    return $cb57feaff75246de$export$dd1bc94b04021eeb;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "classNameOf", function() {
    return $cb57feaff75246de$export$a09f818797e212c4;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "assertInheritance", function() {
    return $cb57feaff75246de$export$170f4e08cad8229d;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "proxyPrototype", function() {
    return $cb57feaff75246de$export$2a489b3f92f4996a;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "isUnsafeNumeric", function() {
    return $cb57feaff75246de$export$67a6ce548ae77071;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "byteLength", function() {
    return $cb57feaff75246de$export$a48f0734ac7c2329;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "toHyphenCase", function() {
    return $cb57feaff75246de$export$3f34ca2fef821bbd;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "toCamelCase", function() {
    return $cb57feaff75246de$export$86f54f62aa7a7514;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "uniqueID", function() {
    return $cb57feaff75246de$export$89912e019eef22aa;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "encodeBase64", function() {
    return $cb57feaff75246de$export$8fb536984ec8b4d7;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "decodeBase64", function() {
    return $cb57feaff75246de$export$94fdf11bafc8de6b;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "objectFrom", function() {
    return $cb57feaff75246de$export$1c8ba402144543e5;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "DiffStatus", function() {
    return $cb57feaff75246de$export$2ddabb89308e1a22;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "diffKeys", function() {
    return $cb57feaff75246de$export$14527669107aa301;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "groupBy", function() {
    return $cb57feaff75246de$export$3f063810d7bf01bd;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "likeArray", function() {
    return $cb57feaff75246de$export$b5a4d6f439a5044d;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "isTypedArray", function() {
    return $cb57feaff75246de$export$b119cc7e1840e59c;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "makeArray", function() {
    return $cb57feaff75246de$export$7b85fd78dd236198;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "splitArray", function() {
    return $cb57feaff75246de$export$697c3df919c0e61a;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "countBy", function() {
    return $cb57feaff75246de$export$1d012a0dff3dab06;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "findDeep", function() {
    return $cb57feaff75246de$export$e6b5ff3168b5942b;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "treeFrom", function() {
    return $cb57feaff75246de$export$fbc9cd6af26fa64f;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "cache", function() {
    return $cb57feaff75246de$export$69a3209f1a06c04d;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "createAsyncIterator", function() {
    return $cb57feaff75246de$export$86c18c6347f4a8c4;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "mergeStream", function() {
    return $cb57feaff75246de$export$dce9414bed0662c;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$9b05bcda60cc529c$exports, "ByteSize", function() {
    return $cb57feaff75246de$export$271f7c16f175f804;
});
var $cb57feaff75246de$var$$6a9944941b4c1893$exports = {};
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$6a9944941b4c1893$exports, "sum", function() {
    return $cb57feaff75246de$export$8a63f25cc62965f1;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$6a9944941b4c1893$exports, "averageOf", function() {
    return $cb57feaff75246de$export$e1f36757ecda301d;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$6a9944941b4c1893$exports, "varianceOf", function() {
    return $cb57feaff75246de$export$8e694e1eafd55acb;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$6a9944941b4c1893$exports, "standardDeviationOf", function() {
    return $cb57feaff75246de$export$57d7c52a66287430;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$6a9944941b4c1893$exports, "hypotenuseOf", function() {
    return $cb57feaff75246de$export$2b4693832ca3ce16;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$6a9944941b4c1893$exports, "carryFloat", function() {
    return $cb57feaff75246de$export$5b784e078da1ce6;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$6a9944941b4c1893$exports, "fixFloat", function() {
    return $cb57feaff75246de$export$17ec9c9f4f23588c;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$6a9944941b4c1893$exports, "Scalar", function() {
    return $cb57feaff75246de$export$595dbf49c602a1f;
});
function $cb57feaff75246de$export$8a63f25cc62965f1(...data) {
    return data.reduce((sum, item)=>sum + item, 0);
}
function $cb57feaff75246de$export$e1f36757ecda301d(...data) {
    return $cb57feaff75246de$export$8a63f25cc62965f1(...data) / data.length;
}
function $cb57feaff75246de$export$8e694e1eafd55acb(data, sample = false) {
    const average = $cb57feaff75246de$export$e1f36757ecda301d(...data);
    const summary = $cb57feaff75246de$export$8a63f25cc62965f1(...data.map((item)=>(item - average) ** 2));
    return summary / (data.length - (sample ? 1 : 0));
}
function $cb57feaff75246de$export$57d7c52a66287430(data, sample = false) {
    return Math.sqrt($cb57feaff75246de$export$8e694e1eafd55acb(data, sample));
}
function $cb57feaff75246de$export$2b4693832ca3ce16(...data) {
    return Math.sqrt($cb57feaff75246de$export$8a63f25cc62965f1(...data.map((item)=>item ** 2)));
}
function $cb57feaff75246de$export$5b784e078da1ce6(raw, length) {
    const text = raw.toFixed(length + 2);
    const offset = text.indexOf('.') + length + 1;
    const cut = (text)=>text.slice(0, offset - (length ? 0 : 1));
    if (!+text.slice(offset)) return cut(text);
    const result = cut((+cut(text) + 10 ** -length).toFixed(length));
    return result.includes('.') ? result.padEnd(offset, '0') : result;
}
function $cb57feaff75246de$export$17ec9c9f4f23588c(raw, length = 2) {
    const text = raw.toFixed(length + 2);
    const floatOffset = text.indexOf('.');
    if (floatOffset < 0) return length ? `${text}.${'0'.repeat(length)}` : text;
    const offset = floatOffset + length + 1;
    const before = +text[offset - 1], anchor = +text[offset], after = +text[offset + 1];
    const carry = anchor > 5 || anchor === 5 && (!!after || !!(before % 2));
    if (carry) return $cb57feaff75246de$export$5b784e078da1ce6(raw, length);
    const result = text.slice(0, offset - (length ? 0 : 1));
    return result.includes('.') ? result.padEnd(offset, '0') : result;
}
class $cb57feaff75246de$export$595dbf49c602a1f {
    constructor(value){
        this.value = value;
    }
    valueOf() {
        return this.value;
    }
    toShortString(fractionDigits = 2) {
        const { units: units, value: value } = this;
        const { base: base, name: name } = [
            ...units
        ].reverse().find(({ base: base })=>Math.abs(value) >= base) || units[0];
        return `${(value / base).toFixed(fractionDigits)} ${name}`;
    }
    static distanceOf(a, b) {
        return Reflect.construct(this, [
            a - b
        ]);
    }
}
const $cb57feaff75246de$export$61cc6ed0f143570b = (value)=>!(value != null) || Number.isNaN(value);
const $cb57feaff75246de$export$dd1bc94b04021eeb = (value)=>$cb57feaff75246de$export$61cc6ed0f143570b(value) || (typeof value === 'object' ? !Object.keys(value).length : value === '');
const $cb57feaff75246de$export$a09f818797e212c4 = (data)=>Object.prototype.toString.call(data).slice(8, -1);
const $cb57feaff75246de$export$170f4e08cad8229d = (Sub, Super)=>Sub.prototype instanceof Super;
function $cb57feaff75246de$export$2a489b3f92f4996a(target, dataStore, setter) {
    const prototype = Object.getPrototypeOf(target);
    const prototypeProxy = new Proxy(prototype, {
        set: (_, key, value, receiver)=>{
            if (key in receiver) Reflect.set(prototype, key, value, receiver);
            else dataStore[key] = value;
            setter?.(key, value);
            return true;
        },
        get: (prototype, key, receiver)=>key in dataStore ? dataStore[key] : Reflect.get(prototype, key, receiver)
    });
    Object.setPrototypeOf(target, prototypeProxy);
}
const $cb57feaff75246de$export$67a6ce548ae77071 = (raw)=>/^[\d.]+$/.test(raw) && raw.localeCompare(Number.MAX_SAFE_INTEGER + '', undefined, {
        numeric: true
    }) > 0;
const $cb57feaff75246de$export$a48f0734ac7c2329 = (raw)=>raw.replace(/[^\u0021-\u007e\uff61-\uffef]/g, 'xx').length;
const $cb57feaff75246de$export$3f34ca2fef821bbd = (raw)=>raw.replace(/[A-Z]+|[^A-Za-z][A-Za-z]/g, (match, offset)=>`${offset ? '-' : ''}${(match[1] || match[0]).toLowerCase()}`);
const $cb57feaff75246de$export$86f54f62aa7a7514 = (raw, large = false)=>raw.replace(/^[A-Za-z]|[^A-Za-z][A-Za-z]/g, (match, offset)=>offset || large ? (match[1] || match[0]).toUpperCase() : match.toLowerCase());
const $cb57feaff75246de$export$89912e019eef22aa = ()=>(Date.now() + parseInt((Math.random() + '').slice(2))).toString(36);
const $cb57feaff75246de$export$8fb536984ec8b4d7 = (input)=>btoa(String.fromCharCode(...new TextEncoder().encode(input)));
const $cb57feaff75246de$export$94fdf11bafc8de6b = (input)=>new TextDecoder().decode(Uint8Array.from(atob(input), (char)=>char.charCodeAt(0)));
const $cb57feaff75246de$export$1c8ba402144543e5 = (values, keys)=>Object.fromEntries(values.map((value, index)=>[
            keys[index],
            value
        ]));
var $cb57feaff75246de$export$2ddabb89308e1a22 = /*#__PURE__*/ function(DiffStatus) {
    DiffStatus[DiffStatus["Old"] = -1] = "Old";
    DiffStatus[DiffStatus["Same"] = 0] = "Same";
    DiffStatus[DiffStatus["New"] = 1] = "New";
    return DiffStatus;
}({});
function $cb57feaff75246de$export$14527669107aa301(oldList, newList) {
    const map = {};
    for (const item of oldList)map[item] = -1;
    for (const item of newList){
        map[item] ||= 0;
        map[item] += 1;
    }
    return {
        map: map,
        group: $cb57feaff75246de$export$3f063810d7bf01bd(Object.entries(map), ([key, status])=>status)
    };
}
function $cb57feaff75246de$export$b5a4d6f439a5044d(data) {
    if ($cb57feaff75246de$export$61cc6ed0f143570b(data)) return false;
    const { length: length } = data;
    return typeof length === 'number' && length >= 0 && ~~length === length;
}
const $cb57feaff75246de$export$b119cc7e1840e59c = (data)=>data instanceof Object.getPrototypeOf(Int8Array);
function $cb57feaff75246de$export$7b85fd78dd236198(data) {
    if (data instanceof Array) return data;
    if ($cb57feaff75246de$export$61cc6ed0f143570b(data)) return [];
    if ($cb57feaff75246de$export$b5a4d6f439a5044d(data)) return Array.from(data);
    return [
        data
    ];
}
const $cb57feaff75246de$export$697c3df919c0e61a = (array, unitLength)=>array.reduce((grid, item, index)=>{
        (grid[~~(index / unitLength)] ||= [])[index % unitLength] = item;
        return grid;
    }, []);
function $cb57feaff75246de$export$3f063810d7bf01bd(list, iteratee) {
    const data = {};
    for (const item of list){
        let keys = iteratee instanceof Function ? iteratee(item) : item[iteratee];
        if (!(keys instanceof Array)) keys = [
            keys
        ];
        for (const key of new Set(keys.filter((key)=>key != null)))(data[key] = data[key] || []).push(item);
    }
    return data;
}
function $cb57feaff75246de$export$1d012a0dff3dab06(list, iteratee) {
    const group = $cb57feaff75246de$export$3f063810d7bf01bd(list, iteratee);
    const sortedList = Object.entries(group).map(([key, { length: length }])=>[
            key,
            length
        ]);
    return Object.fromEntries(sortedList);
}
function $cb57feaff75246de$export$e6b5ff3168b5942b(list, subKey, handler) {
    for (const item of list){
        if (handler(item)) return [
            item
        ];
        if (item[subKey] instanceof Array) {
            const result = $cb57feaff75246de$export$e6b5ff3168b5942b(item[subKey], subKey, handler);
            if (result.length) return [
                item,
                ...result
            ];
        }
    }
    return [];
}
function $cb57feaff75246de$export$fbc9cd6af26fa64f(list, idKey = 'id', parentIdKey = 'parentId', childrenKey = 'children') {
    list = globalThis.structuredClone?.(list) || JSON.parse(JSON.stringify(list));
    const map = {};
    const roots = [];
    for (const item of list)map[item[idKey]] = item;
    for (const item of list){
        const parent = map[item[parentIdKey]];
        if (!parent) roots.push(item);
        else {
            parent[childrenKey] ||= [];
            parent[childrenKey].push(item);
        }
    }
    if (!roots[0]) throw new ReferenceError('No root node is found');
    return roots;
}
function $cb57feaff75246de$export$69a3209f1a06c04d(executor, title) {
    var cacheData;
    return function(...data) {
        if (cacheData != null) return cacheData;
        console.trace(`[Cache] execute: ${title}`);
        cacheData = executor.call(this, ()=>cacheData = undefined, ...data);
        Promise.resolve(cacheData).then((data)=>console.log(`[Cache] refreshed: ${title} => ${data}`), (error)=>console.error(`[Cache] failed: ${error?.message || error}`));
        return cacheData;
    };
}
async function* $cb57feaff75246de$export$86c18c6347f4a8c4(executor) {
    let { promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers();
    const doneSymbol = Symbol('done'), done = Promise.withResolvers();
    const disposer = executor({
        next: (value)=>resolve(value),
        error: (error)=>{
            reject(error);
            // @ts-ignore
            disposer?.();
        },
        complete: ()=>{
            done.resolve(doneSymbol);
            // @ts-ignore
            disposer?.();
        }
    });
    while(true){
        const value = await Promise.race([
            promise,
            done.promise
        ]);
        if (value === doneSymbol) return;
        yield value;
        ({ promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers());
    }
}
async function* $cb57feaff75246de$export$dce9414bed0662c(...sources) {
    var iterators = sources.map((item)=>item());
    while(iterators[0]){
        const dones = [];
        for(let i = 0, iterator; iterator = iterators[i]; i++){
            const { done: done, value: value } = await iterator.next();
            if (!done) yield value;
            else dones.push(i);
        }
        iterators = iterators.filter((_, i)=>!dones.includes(i));
    }
}
class $cb57feaff75246de$export$271f7c16f175f804 extends $cb57feaff75246de$export$595dbf49c602a1f {
    constructor(...args){
        super(...args), this.units = [
            '',
            'K',
            'M',
            'G',
            'T',
            'P',
            'E',
            'Z',
            'Y'
        ].map((name, i)=>({
                base: 1024 ** i,
                name: name + 'B'
            }));
    }
}
var $cb57feaff75246de$var$$f872d8bba1c0f79f$exports = {};
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$f872d8bba1c0f79f$exports, "Second", function() {
    return $cb57feaff75246de$export$c489aa6f7fd82b1a;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$f872d8bba1c0f79f$exports, "Minute", function() {
    return $cb57feaff75246de$export$cbd942915f33be50;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$f872d8bba1c0f79f$exports, "Quarter", function() {
    return $cb57feaff75246de$export$9b886f8493244014;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$f872d8bba1c0f79f$exports, "Hour", function() {
    return $cb57feaff75246de$export$e99cbb807a5bb10d;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$f872d8bba1c0f79f$exports, "Day", function() {
    return $cb57feaff75246de$export$7a9a31a911eb9a20;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$f872d8bba1c0f79f$exports, "Week", function() {
    return $cb57feaff75246de$export$fca4f8121099df57;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$f872d8bba1c0f79f$exports, "Year", function() {
    return $cb57feaff75246de$export$6ce2f08d515512;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$f872d8bba1c0f79f$exports, "Month", function() {
    return $cb57feaff75246de$export$951c8378cdfec6e6;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$f872d8bba1c0f79f$exports, "Season", function() {
    return $cb57feaff75246de$export$1a4097b876a13bf7;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$f872d8bba1c0f79f$exports, "Timestamp", function() {
    return $cb57feaff75246de$export$d9bcbd5e1ff81430;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$f872d8bba1c0f79f$exports, "diffTime", function() {
    return $cb57feaff75246de$export$506c8e8f8c8edda;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$f872d8bba1c0f79f$exports, "formatDate", function() {
    return $cb57feaff75246de$export$3ae94a2503e890a1;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$f872d8bba1c0f79f$exports, "changeYear", function() {
    return $cb57feaff75246de$export$7e1c707225b48c34;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$f872d8bba1c0f79f$exports, "changeMonth", function() {
    return $cb57feaff75246de$export$62ad822b3a5fd9a0;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$f872d8bba1c0f79f$exports, "changeDate", function() {
    return $cb57feaff75246de$export$9e85258502147ffb;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$f872d8bba1c0f79f$exports, "makeDateRange", function() {
    return $cb57feaff75246de$export$3c1f2e5bc03748e2;
});
const $cb57feaff75246de$export$c489aa6f7fd82b1a = 1000;
const $cb57feaff75246de$export$cbd942915f33be50 = $cb57feaff75246de$export$c489aa6f7fd82b1a * 60;
const $cb57feaff75246de$export$9b886f8493244014 = $cb57feaff75246de$export$cbd942915f33be50 * 15;
const $cb57feaff75246de$export$e99cbb807a5bb10d = $cb57feaff75246de$export$9b886f8493244014 * 4;
const $cb57feaff75246de$export$7a9a31a911eb9a20 = $cb57feaff75246de$export$e99cbb807a5bb10d * 24;
const $cb57feaff75246de$export$fca4f8121099df57 = $cb57feaff75246de$export$7a9a31a911eb9a20 * 7;
const $cb57feaff75246de$export$6ce2f08d515512 = $cb57feaff75246de$export$7a9a31a911eb9a20 * 365;
const $cb57feaff75246de$export$951c8378cdfec6e6 = $cb57feaff75246de$export$6ce2f08d515512 / 12;
const $cb57feaff75246de$export$1a4097b876a13bf7 = $cb57feaff75246de$export$951c8378cdfec6e6 * 3;
class $cb57feaff75246de$export$d9bcbd5e1ff81430 extends $cb57feaff75246de$export$595dbf49c602a1f {
    toShortString(fractionDigits = 0) {
        return super.toShortString(fractionDigits);
    }
    constructor(...args){
        super(...args), this.units = [
            {
                base: $cb57feaff75246de$export$c489aa6f7fd82b1a,
                name: 's'
            },
            {
                base: $cb57feaff75246de$export$cbd942915f33be50,
                name: 'm'
            },
            {
                base: $cb57feaff75246de$export$e99cbb807a5bb10d,
                name: 'H'
            },
            {
                base: $cb57feaff75246de$export$7a9a31a911eb9a20,
                name: 'D'
            },
            {
                base: $cb57feaff75246de$export$fca4f8121099df57,
                name: 'W'
            },
            {
                base: $cb57feaff75246de$export$951c8378cdfec6e6,
                name: 'M'
            },
            {
                base: $cb57feaff75246de$export$6ce2f08d515512,
                name: 'Y'
            }
        ];
    }
}
function $cb57feaff75246de$export$506c8e8f8c8edda(end, start = new Date()) {
    const timeDistance = $cb57feaff75246de$export$d9bcbd5e1ff81430.distanceOf(+new Date(end), +new Date(start));
    const [value, unit] = timeDistance.toShortString().split(/\s+/);
    return {
        distance: +value,
        unit: unit
    };
}
function $cb57feaff75246de$var$$f872d8bba1c0f79f$var$fitUnit(value) {
    value = +value + '';
    return (template)=>(value.length < template.length ? value.padStart(template.length, '0') : value).slice(-Math.max(template.length, 2));
}
function $cb57feaff75246de$export$3ae94a2503e890a1(time = new Date(), template = 'YYYY-MM-DD HH:mm:ss') {
    const [year, month, day, hour, minute, second, millisecond] = new Date(time).toJSON().split(/\D/);
    return template.replace(/ms/g, millisecond).replace(/Y+/g, $cb57feaff75246de$var$$f872d8bba1c0f79f$var$fitUnit(year)).replace(/M+/g, $cb57feaff75246de$var$$f872d8bba1c0f79f$var$fitUnit(month)).replace(/D+/g, $cb57feaff75246de$var$$f872d8bba1c0f79f$var$fitUnit(day)).replace(/H+/g, $cb57feaff75246de$var$$f872d8bba1c0f79f$var$fitUnit(hour)).replace(/m+/g, $cb57feaff75246de$var$$f872d8bba1c0f79f$var$fitUnit(minute)).replace(/s+/g, $cb57feaff75246de$var$$f872d8bba1c0f79f$var$fitUnit(second));
}
function $cb57feaff75246de$export$7e1c707225b48c34(date, delta) {
    date = new Date(date);
    date.setFullYear(date.getFullYear() + delta);
    return date;
}
function $cb57feaff75246de$export$62ad822b3a5fd9a0(date, delta) {
    date = new Date(date);
    const month = date.getMonth() + delta;
    date = $cb57feaff75246de$export$7e1c707225b48c34(date, Math.floor(month / 12));
    delta = month % 12;
    date.setMonth(delta < 0 ? 12 + delta : delta);
    return date;
}
const $cb57feaff75246de$export$9e85258502147ffb = (date, unit, delta)=>unit === $cb57feaff75246de$export$6ce2f08d515512 ? $cb57feaff75246de$export$7e1c707225b48c34(date, delta) : unit === $cb57feaff75246de$export$951c8378cdfec6e6 ? $cb57feaff75246de$export$62ad822b3a5fd9a0(date, delta) : new Date(+new Date(date) + delta * unit);
const $cb57feaff75246de$var$$f872d8bba1c0f79f$var$DateLength2Unit = {
    4: $cb57feaff75246de$export$6ce2f08d515512,
    7: $cb57feaff75246de$export$951c8378cdfec6e6,
    10: $cb57feaff75246de$export$7a9a31a911eb9a20,
    13: $cb57feaff75246de$export$e99cbb807a5bb10d,
    16: $cb57feaff75246de$export$cbd942915f33be50,
    19: $cb57feaff75246de$export$c489aa6f7fd82b1a
};
function $cb57feaff75246de$export$3c1f2e5bc03748e2(value) {
    const defaultValue = `2025-01-01T00:00:00.000Z`;
    const startedAt = new Date(value + defaultValue.slice(value.length));
    const endedAt = $cb57feaff75246de$export$9e85258502147ffb(startedAt, $cb57feaff75246de$var$$f872d8bba1c0f79f$var$DateLength2Unit[value.length], 1);
    return [
        startedAt,
        endedAt
    ];
}
var $cb57feaff75246de$var$$ba0e5dc395660a7c$exports = {};
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$ba0e5dc395660a7c$exports, "parseJSON", function() {
    return $cb57feaff75246de$export$27924e57e9afff7f;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$ba0e5dc395660a7c$exports, "toJSValue", function() {
    return $cb57feaff75246de$export$7ea17d45ecdcf634;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$ba0e5dc395660a7c$exports, "parseTextTable", function() {
    return $cb57feaff75246de$export$bb8626e4916f587b;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$ba0e5dc395660a7c$exports, "parseTextTableAsync", function() {
    return $cb57feaff75246de$export$88182f6768071c72;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$ba0e5dc395660a7c$exports, "readTextTable", function() {
    return $cb57feaff75246de$export$2427785258f88523;
});
function $cb57feaff75246de$export$27924e57e9afff7f(raw) {
    function parseItem(value) {
        if (typeof value === 'string' && /^\d+(-\d{1,2}){1,2}/.test(value)) {
            const date = new Date(value);
            if (!Number.isNaN(+date)) return date;
        }
        return value;
    }
    const value = parseItem(raw);
    if (typeof value !== 'string' || $cb57feaff75246de$export$67a6ce548ae77071(value)) return value;
    try {
        return JSON.parse(raw, (key, value)=>parseItem(value));
    } catch  {
        return raw;
    }
}
function $cb57feaff75246de$export$7ea17d45ecdcf634(raw) {
    const parsed = $cb57feaff75246de$export$27924e57e9afff7f(raw);
    if (typeof parsed !== 'string') return parsed;
    const number = +parsed;
    return Number.isNaN(number) || number + '' !== parsed ? parsed : number;
}
function $cb57feaff75246de$var$$ba0e5dc395660a7c$var$readQuoteValue(raw) {
    const quote = raw[0];
    const index = raw.indexOf(quote, 1);
    if (index < 0) throw SyntaxError(`A ${quote} is missing`);
    return raw.slice(1, index);
}
function $cb57feaff75246de$var$$ba0e5dc395660a7c$var$parseRow(row, separator = ',') {
    const list = [];
    do {
        let value;
        if (row[0] === '"' || row[0] === "'") {
            value = $cb57feaff75246de$var$$ba0e5dc395660a7c$var$readQuoteValue(row);
            row = row.slice(value.length + 3);
        } else {
            const index = row.indexOf(separator);
            if (index > -1) {
                value = row.slice(0, index);
                row = row.slice(index + 1);
            } else {
                value = row;
                row = '';
            }
        }
        list.push($cb57feaff75246de$export$7ea17d45ecdcf634(value.trim()));
    }while (row);
    return list;
}
function $cb57feaff75246de$export$bb8626e4916f587b(raw, header, separator = ',') {
    const data = raw.trim().split(/[\r\n]+/).map((row)=>$cb57feaff75246de$var$$ba0e5dc395660a7c$var$parseRow(row, separator));
    return !header ? data : data.slice(1).map((row)=>$cb57feaff75246de$export$1c8ba402144543e5(row, data[0]));
}
const $cb57feaff75246de$export$88182f6768071c72 = async (raw)=>Array.fromAsync($cb57feaff75246de$export$2427785258f88523(raw[Symbol.iterator]()));
async function* $cb57feaff75246de$var$$ba0e5dc395660a7c$var$characterStream(chunks) {
    for await (const chunk of chunks)yield* chunk;
}
async function* $cb57feaff75246de$var$$ba0e5dc395660a7c$var$parseCharacterStream(chars, separator = ',') {
    let inQuote = false;
    let quoteChar = '';
    let prevChar = '';
    let cellBuffer = '';
    let currentRow = [];
    const completeCell = ()=>{
        currentRow.push($cb57feaff75246de$export$7ea17d45ecdcf634(cellBuffer.trim()));
        cellBuffer = '';
    };
    for await (const char of chars){
        if (char === '\n' || char === '\r') {
            if (char === '\n' && prevChar === '\r') {
                prevChar = char;
                continue;
            }
            completeCell();
            if (currentRow.length > 1 || currentRow[0]) yield currentRow;
            currentRow = [];
        } else if ((char === '"' || char === "'") && !inQuote && cellBuffer.trim() === '') {
            inQuote = true;
            quoteChar = char;
        } else if (char === quoteChar && inQuote) {
            inQuote = false;
            quoteChar = '';
        } else if (inQuote) cellBuffer += char;
        else if (char === separator) completeCell();
        else cellBuffer += char;
        prevChar = char;
    }
    if (cellBuffer || currentRow.length > 0) {
        completeCell();
        if (currentRow.length > 1 || currentRow[0]) yield currentRow;
    }
}
async function* $cb57feaff75246de$export$2427785258f88523(chunks, header, separator = ',') {
    let headerRow;
    let isFirstRow = true;
    const chars = $cb57feaff75246de$var$$ba0e5dc395660a7c$var$characterStream(chunks);
    for await (const row of $cb57feaff75246de$var$$ba0e5dc395660a7c$var$parseCharacterStream(chars, separator))if (header && isFirstRow) {
        headerRow = row;
        isFirstRow = false;
    } else yield header && headerRow ? $cb57feaff75246de$export$1c8ba402144543e5(row, headerRow) : row;
}
var $cb57feaff75246de$var$$083124ac4b1a50a0$exports = {};
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$083124ac4b1a50a0$exports, "isXDomain", function() {
    return $cb57feaff75246de$export$71e6483fc2b024eb;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$083124ac4b1a50a0$exports, "parseURLData", function() {
    return $cb57feaff75246de$export$eb9b2aadbe449a20;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$083124ac4b1a50a0$exports, "buildURLData", function() {
    return $cb57feaff75246de$export$13397a83aa5915d6;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$083124ac4b1a50a0$exports, "blobOf", function() {
    return $cb57feaff75246de$export$fd89523fba250fa4;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$083124ac4b1a50a0$exports, "blobFrom", function() {
    return $cb57feaff75246de$export$504fbde693c1771c;
});
const $cb57feaff75246de$export$71e6483fc2b024eb = (URI)=>new URL(URI, document.baseURI).origin !== location.origin;
function $cb57feaff75246de$export$eb9b2aadbe449a20(raw = globalThis.location?.search || '', toBuiltIn = true) {
    const rawData = raw.split('#').map((URI)=>{
        const [before, after] = URI.split('?');
        return new URLSearchParams(after || (before.includes('=') ? before : ''));
    }).join('&');
    const data = new URLSearchParams(rawData);
    return Object.fromEntries([
        ...data.keys()
    ].map((key)=>{
        const list = toBuiltIn ? data.getAll(key).map($cb57feaff75246de$export$27924e57e9afff7f) : data.getAll(key);
        return [
            key,
            list.length < 2 ? list[0] : list
        ];
    }));
}
const $cb57feaff75246de$var$$083124ac4b1a50a0$var$stringify = (value)=>typeof value === 'string' ? value : $cb57feaff75246de$export$b5a4d6f439a5044d(value) ? $cb57feaff75246de$export$7b85fd78dd236198(value) + '' : JSON.stringify(value);
function $cb57feaff75246de$export$13397a83aa5915d6(map) {
    if (!(map instanceof Array)) map = Object.entries(map);
    const list = map.map(([key, value])=>!$cb57feaff75246de$export$dd1bc94b04021eeb(value) && [
            key,
            $cb57feaff75246de$var$$083124ac4b1a50a0$var$stringify(value)
        ]).filter(Boolean);
    return new URLSearchParams(list);
}
const $cb57feaff75246de$export$fd89523fba250fa4 = async (URI)=>(await fetch(URI + '')).blob();
const $cb57feaff75246de$var$$083124ac4b1a50a0$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
function $cb57feaff75246de$export$504fbde693c1771c(URI) {
    var [_, type, __, base64, data] = $cb57feaff75246de$var$$083124ac4b1a50a0$var$DataURI.exec(URI) || [];
    data = base64 ? atob(data) : data;
    const aBuffer = Uint8Array.from(data, (char)=>char.charCodeAt(0));
    return new Blob([
        aBuffer
    ], {
        type: type
    });
}
var $cb57feaff75246de$var$$d677628cc2ac1e37$exports = {};
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$d677628cc2ac1e37$exports, "parseCookie", function() {
    return $cb57feaff75246de$export$d0eaf3e94be578f6;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$d677628cc2ac1e37$exports, "setCookie", function() {
    return $cb57feaff75246de$export$110700823644f4a6;
});
const $cb57feaff75246de$export$d0eaf3e94be578f6 = (value = globalThis.document?.cookie)=>value ? Object.fromEntries(value.split(/;\s*/).map((item)=>item.split('='))) : {};
function $cb57feaff75246de$export$110700823644f4a6(key, value, attributes = {}) {
    const data = `${key}=${value}`, option = Object.entries(attributes).map(([key, value])=>typeof value === 'boolean' ? value ? key : '' : `${key}=${value}`).filter(Boolean).join('; ');
    document.cookie = `${data}; expires=${new Date(0)}`;
    return document.cookie = `${data}; ${option}`;
}
var $cb57feaff75246de$var$$50872bf213056663$exports = {};
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$50872bf213056663$exports, "makeCRC32", function() {
    return $cb57feaff75246de$export$1b9ac4d3de3ffd2e;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$50872bf213056663$exports, "makeSHA", function() {
    return $cb57feaff75246de$export$d51f3b55e8d1aa73;
});
const $cb57feaff75246de$var$$50872bf213056663$var$CRC_32_Table = Array.from(new Array(256), (_, cell)=>{
    for(var j = 0; j < 8; j++)if (cell & 1) cell = cell >> 1 & 0x7fffffff ^ 0xedb88320;
    else cell = cell >> 1 & 0x7fffffff;
    return cell;
});
function $cb57feaff75246de$export$1b9ac4d3de3ffd2e(raw) {
    var value = 0xffffffff;
    for (const char of raw)value = value >> 8 & 0x00ffffff ^ $cb57feaff75246de$var$$50872bf213056663$var$CRC_32_Table[value & 0xff ^ char.charCodeAt(0)];
    return '0x' + ((value ^ 0xffffffff) >>> 0).toString(16);
}
if (typeof self === 'object') {
    if ('msCrypto' in globalThis) {
        // @ts-ignore
        const { subtle: subtle } = globalThis.crypto = globalThis.msCrypto;
        for(const key in subtle){
            const origin = subtle[key];
            if (origin instanceof Function) subtle[key] = function() {
                const observer = origin.apply(this, arguments);
                return new Promise((resolve, reject)=>{
                    observer.oncomplete = ({ target: target })=>resolve(target.result);
                    observer.onabort = observer.onerror = reject;
                });
            };
        }
    }
    const { crypto: crypto1 } = globalThis;
    if (!crypto1?.subtle && crypto1?.['webkitSubtle']) crypto1.subtle = crypto1['webkitSubtle'];
}
async function $cb57feaff75246de$export$d51f3b55e8d1aa73(raw, algorithm = 'SHA-1') {
    const buffer = await crypto.subtle.digest(algorithm, new TextEncoder().encode(raw));
    return Array.from(new Uint8Array(buffer), (byte)=>byte.toString(16).padStart(2, '0')).join('');
}
var $cb57feaff75246de$var$$93a3089d2937b23f$exports = {};
var $cb57feaff75246de$var$$3e0a089cc13f69ad$exports = {};
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$3e0a089cc13f69ad$exports, "XMLNamespace", function() {
    return $cb57feaff75246de$export$f5a4056b78c72efa;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$3e0a089cc13f69ad$exports, "templateOf", function() {
    return $cb57feaff75246de$export$2ee022bbbc550b25;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$3e0a089cc13f69ad$exports, "elementTypeOf", function() {
    return $cb57feaff75246de$export$a549dd5cef7f8327;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$3e0a089cc13f69ad$exports, "isHTMLElementClass", function() {
    return $cb57feaff75246de$export$8eece510bcb9c62c;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$3e0a089cc13f69ad$exports, "tagNameOf", function() {
    return $cb57feaff75246de$export$b8a1af58c024fefd;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$3e0a089cc13f69ad$exports, "isDOMReadOnly", function() {
    return $cb57feaff75246de$export$a2cf0d4bb6e06de4;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$3e0a089cc13f69ad$exports, "parseDOM", function() {
    return $cb57feaff75246de$export$d66b332881d9723f;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$3e0a089cc13f69ad$exports, "stringifyDOM", function() {
    return $cb57feaff75246de$export$b0709844452f8b6b;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$3e0a089cc13f69ad$exports, "walkDOM", function() {
    return $cb57feaff75246de$export$5118471ee5d5453b;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$3e0a089cc13f69ad$exports, "getVisibleText", function() {
    return $cb57feaff75246de$export$be4650432daa84fd;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$3e0a089cc13f69ad$exports, "splitPages", function() {
    return $cb57feaff75246de$export$578e38b4a3e0b255;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$3e0a089cc13f69ad$exports, "importCSS", function() {
    return $cb57feaff75246de$export$7cd14c57bbb84350;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$3e0a089cc13f69ad$exports, "stringifyCSS", function() {
    return $cb57feaff75246de$export$5100419dfae0456d;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$3e0a089cc13f69ad$exports, "insertToCursor", function() {
    return $cb57feaff75246de$export$28d9d24a8cd0ffc2;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$3e0a089cc13f69ad$exports, "scrollTo", function() {
    return $cb57feaff75246de$export$3f99968195accfaf;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$3e0a089cc13f69ad$exports, "watchScroll", function() {
    return $cb57feaff75246de$export$eafdbaa868ea9975;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$3e0a089cc13f69ad$exports, "watchVisible", function() {
    return $cb57feaff75246de$export$36a0c1ca2ae264fa;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$3e0a089cc13f69ad$exports, "formToJSON", function() {
    return $cb57feaff75246de$export$86d7c59254d6a2c9;
});
const $cb57feaff75246de$export$f5a4056b78c72efa = {
    html: 'http://www.w3.org/1999/xhtml',
    svg: 'http://www.w3.org/2000/svg',
    math: 'http://www.w3.org/1998/Math/MathML'
};
const $cb57feaff75246de$var$$3e0a089cc13f69ad$var$templateMap = {};
function $cb57feaff75246de$export$2ee022bbbc550b25(tagName) {
    if ($cb57feaff75246de$var$$3e0a089cc13f69ad$var$templateMap[tagName]) return $cb57feaff75246de$var$$3e0a089cc13f69ad$var$templateMap[tagName];
    const spawn = document.createElement('template');
    spawn.innerHTML = `<${tagName} />`;
    return $cb57feaff75246de$var$$3e0a089cc13f69ad$var$templateMap[tagName] = spawn.content.firstElementChild;
}
function $cb57feaff75246de$export$a549dd5cef7f8327(tagName) {
    if (tagName.includes('-')) return 'html';
    const [prefix, localName] = tagName.split(':');
    if (localName) return prefix === 'html' ? 'html' : 'xml';
    const node = $cb57feaff75246de$export$2ee022bbbc550b25(tagName);
    return node instanceof HTMLElement && !(node instanceof HTMLUnknownElement) ? 'html' : 'xml';
}
const $cb57feaff75246de$export$8eece510bcb9c62c = (Class)=>$cb57feaff75246de$export$170f4e08cad8229d(Class, HTMLElement);
const $cb57feaff75246de$var$$3e0a089cc13f69ad$var$nameMap = new WeakMap();
function $cb57feaff75246de$export$b8a1af58c024fefd(Class) {
    const name = $cb57feaff75246de$var$$3e0a089cc13f69ad$var$nameMap.get(Class);
    if (name) return name;
    var { tagName: tagName } = new Class();
    $cb57feaff75246de$var$$3e0a089cc13f69ad$var$nameMap.set(Class, tagName = tagName.toLowerCase());
    return tagName;
}
function $cb57feaff75246de$export$a2cf0d4bb6e06de4(tagName, propertyName) {
    /**
     * fetch from https://html.spec.whatwg.org/
     */ const ReadOnly_Properties = [
        [
            HTMLLinkElement,
            [
                'sizes'
            ]
        ],
        [
            HTMLIFrameElement,
            [
                'sandbox'
            ]
        ],
        [
            HTMLObjectElement,
            [
                'form'
            ]
        ],
        [
            HTMLInputElement,
            [
                'form',
                'list'
            ]
        ],
        [
            HTMLButtonElement,
            [
                'form'
            ]
        ],
        [
            HTMLSelectElement,
            [
                'form'
            ]
        ],
        [
            HTMLTextAreaElement,
            [
                'form'
            ]
        ],
        [
            HTMLOutputElement,
            [
                'form'
            ]
        ],
        [
            HTMLFieldSetElement,
            [
                'form'
            ]
        ]
    ];
    const template = $cb57feaff75246de$export$2ee022bbbc550b25(tagName);
    for (const [Class, keys] of ReadOnly_Properties)if (template instanceof Class && keys.includes(propertyName)) return true;
    return false;
}
function $cb57feaff75246de$export$d66b332881d9723f(HTML) {
    const spawn = document.createElement('template');
    spawn.innerHTML = HTML;
    return [
        ...spawn.content.childNodes
    ].map((node)=>{
        node.remove();
        return node;
    });
}
const $cb57feaff75246de$export$b0709844452f8b6b = (node)=>new XMLSerializer().serializeToString(node).replace(/ xmlns="http:\/\/www.w3.org\/1999\/xhtml"/g, '');
function* $cb57feaff75246de$export$5118471ee5d5453b(root, type) {
    const children = [
        ...root.childNodes
    ];
    if ($cb57feaff75246de$export$dd1bc94b04021eeb(type) || type === root.nodeType) yield root;
    for (const node of children)yield* $cb57feaff75246de$export$5118471ee5d5453b(node, type);
}
function $cb57feaff75246de$export$be4650432daa84fd(root) {
    var text = '';
    for (const { nodeType: nodeType, parentElement: parentElement, nodeValue: nodeValue } of $cb57feaff75246de$export$5118471ee5d5453b(root))if (nodeType === Node.TEXT_NODE && parentElement.getAttribute('aria-hidden') !== 'true') {
        const { width: width, height: height } = parentElement.getBoundingClientRect();
        if (width && height) text += nodeValue.trim().replace(/\s+/g, ' ');
    }
    return text;
}
function $cb57feaff75246de$export$578e38b4a3e0b255({ offsetWidth: offsetWidth, children: children }, pageHeight = 841.89, pageWidth = 595.28) {
    const scrollHeight = pageHeight / pageWidth * offsetWidth;
    var offset = 0;
    return [
        ...children
    ].reduce((pages, node)=>{
        var { offsetTop: top, offsetHeight: height } = node;
        top += offset;
        var bottom = top + height;
        const bottomOffset = bottom / scrollHeight;
        const topIndex = ~~(top / scrollHeight), bottomIndex = ~~bottomOffset;
        if (topIndex !== bottomIndex) offset += height - bottomOffset;
        (pages[bottomIndex] ||= []).push(node);
        return pages;
    }, []);
}
function $cb57feaff75246de$export$7cd14c57bbb84350(URI, { alternate: alternate, ...options } = {}) {
    const style = [
        ...document.styleSheets
    ].find(({ href: href })=>href === URI);
    if (style) return Promise.resolve(style);
    const link = document.createElement('link');
    return new Promise((resolve, reject)=>{
        link.onload = ()=>resolve(link.sheet);
        link.onerror = (_1, _2, _3, _4, error)=>reject(error);
        Object.assign(link, options);
        link.rel = (alternate ? 'alternate ' : '') + 'stylesheet';
        link.href = URI;
        document.head.append(link);
    });
}
function $cb57feaff75246de$export$5100419dfae0456d(data, depth = 0, indent = '    ') {
    const padding = indent.repeat(depth);
    return Object.entries(data).map(([key, value])=>typeof value !== 'object' ? `${padding}${$cb57feaff75246de$export$3f34ca2fef821bbd(key)}: ${value};` : `${padding}${key} {
${$cb57feaff75246de$export$5100419dfae0456d(value, depth + 1, indent)}
${padding}}`).join('\n');
}
function $cb57feaff75246de$export$28d9d24a8cd0ffc2(...nodes) {
    const fragment = document.createDocumentFragment();
    fragment.append(...nodes);
    for (const node of $cb57feaff75246de$export$5118471ee5d5453b(fragment))if (![
        1,
        3,
        11
    ].includes(node.nodeType) || [
        'meta',
        'title',
        'link',
        'script'
    ].includes(node.nodeName.toLowerCase())) node.replaceWith(...node.childNodes);
    const selection = globalThis.getSelection();
    if (!selection) return;
    const range = selection.getRangeAt(0);
    range.deleteContents();
    range.insertNode(fragment);
}
function $cb57feaff75246de$export$3f99968195accfaf(selector, root, align, justify) {
    const [_, ID] = /^#(.+)/.exec(selector) || [];
    if (ID === 'top') window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
    else (root || document).querySelector(ID ? `[id="${ID}"]` : selector)?.scrollIntoView({
        behavior: 'smooth',
        block: align,
        inline: justify
    });
}
const $cb57feaff75246de$export$eafdbaa868ea9975 = (box, handler, depth = 6)=>Array.from(box.querySelectorAll(Array.from(new Array(depth), (_, index)=>`h${++index}`) + ''), (header)=>{
        new IntersectionObserver(([item])=>{
            if (!item.isIntersecting) return;
            const target = item.target;
            handler({
                target: target,
                links: [
                    ...target.ownerDocument.querySelectorAll(`[href="#${target.id}"]`)
                ]
            });
        }).observe(header);
        if (!header.id.trim()) header.id = header.textContent.trim().replace(/\W+/g, '-');
        return {
            level: +header.tagName[1],
            id: header.id,
            text: header.textContent.trim()
        };
    });
function $cb57feaff75246de$export$36a0c1ca2ae264fa(root, handler) {
    var last = document.visibilityState === 'visible' ? 1 : 0;
    function change(state) {
        if (state === 3 || last === 3) handler(state === 3);
        last = state;
    }
    new IntersectionObserver(([{ isIntersecting: isIntersecting }])=>change(isIntersecting ? last | 2 : last & 1)).observe(root);
    document.addEventListener('visibilitychange', ()=>change(document.visibilityState === 'visible' ? last | 1 : last & 2));
}
function $cb57feaff75246de$export$86d7c59254d6a2c9(form) {
    const { elements: elements } = form, data = {};
    for (const field of elements){
        let { name: name, value: value, checked: checked, defaultValue: defaultValue, selectedOptions: selectedOptions, files: files } = field;
        const type = field.type;
        if (!name || value === '') continue;
        const box = type !== 'fieldset' && field.closest('fieldset');
        if (box && box !== form) continue;
        let parsedValue = value;
        switch(type){
            case 'radio':
            case 'checkbox':
                if (checked) parsedValue = !defaultValue || $cb57feaff75246de$export$7ea17d45ecdcf634(defaultValue);
                else if ($cb57feaff75246de$export$b5a4d6f439a5044d(elements.namedItem(name))) continue;
                else parsedValue = false;
                break;
            case 'select-multiple':
                parsedValue = Array.from(selectedOptions, ({ value: value })=>$cb57feaff75246de$export$7ea17d45ecdcf634(value));
                break;
            case 'fieldset':
                parsedValue = $cb57feaff75246de$export$86d7c59254d6a2c9(field);
                break;
            case 'file':
                parsedValue = files && Array.from(files);
                break;
            case 'date':
            case 'datetime-local':
            case 'month':
            case 'hidden':
            case 'number':
            case 'range':
            case 'select-one':
                parsedValue = $cb57feaff75246de$export$7ea17d45ecdcf634(value);
        }
        if (name in data) data[name] = [].concat(data[name], parsedValue);
        else data[name] = !(parsedValue instanceof Array) || !$cb57feaff75246de$export$dd1bc94b04021eeb(parsedValue[1]) ? parsedValue : parsedValue[0];
    }
    return data;
}
var $cb57feaff75246de$var$$bb23e0c794fefbef$exports = {};
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$bb23e0c794fefbef$exports, "sleep", function() {
    return $cb57feaff75246de$export$e772c8ff12451969;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$bb23e0c794fefbef$exports, "asyncLoop", function() {
    return $cb57feaff75246de$export$57207d71b8c929c8;
});
function $cb57feaff75246de$export$e772c8ff12451969(seconds = 1) {
    return new Promise((resolve)=>setTimeout(resolve, seconds * 1000));
}
function $cb57feaff75246de$export$57207d71b8c929c8(executor, seconds = 1) {
    var stop = false;
    (async ()=>{
        while(!stop){
            const result = executor();
            if (result instanceof Promise) await result;
            await $cb57feaff75246de$export$e772c8ff12451969(seconds);
        }
    })();
    return ()=>stop = true;
}
var $cb57feaff75246de$var$$19ed8aeb7905a045$exports = {};
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$19ed8aeb7905a045$exports, "delegate", function() {
    return $cb57feaff75246de$export$10b1921597150314;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$19ed8aeb7905a045$exports, "documentReady", function() {
    return $cb57feaff75246de$export$3e2b244719956741;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$19ed8aeb7905a045$exports, "promisify", function() {
    return $cb57feaff75246de$export$1d1d2ed6b55cf67f;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$19ed8aeb7905a045$exports, "createMessageServer", function() {
    return $cb57feaff75246de$export$2155c0b5a4b77fb8;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$19ed8aeb7905a045$exports, "createMessageClient", function() {
    return $cb57feaff75246de$export$9d97473344489dfc;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$19ed8aeb7905a045$exports, "serviceWorkerUpdate", function() {
    return $cb57feaff75246de$export$d635d04af3887bbe;
});
function $cb57feaff75246de$export$10b1921597150314(selector, handler) {
    return function(event) {
        var node, path = event.composedPath();
        while((node = path.shift()) && node !== event.currentTarget)if (node instanceof HTMLElement && node.matches(selector)) return handler.call(this, event, node, event.detail);
    };
}
const $cb57feaff75246de$export$3e2b244719956741 = typeof window !== 'undefined' ? new Promise((resolve)=>{
    function done() {
        document?.removeEventListener('DOMContentLoaded', done);
        window.removeEventListener('load', done);
        resolve();
    }
    document?.addEventListener('DOMContentLoaded', done);
    window.addEventListener('load', done);
    setTimeout(function check() {
        document?.readyState === 'complete' ? resolve() : setTimeout(check);
    });
}) : Promise.resolve();
function $cb57feaff75246de$export$1d1d2ed6b55cf67f(scope, element) {
    return new Promise((resolve, reject)=>{
        function end(event) {
            resolve(event), clean();
        }
        function cancel(event) {
            reject(event), clean();
        }
        function clean() {
            element.removeEventListener(scope + 'end', end);
            element.removeEventListener(scope + 'cancel', cancel);
        }
        element.addEventListener(scope + 'end', end);
        element.addEventListener(scope + 'cancel', cancel);
    });
}
function $cb57feaff75246de$export$2155c0b5a4b77fb8(handlers) {
    async function server({ data: { type: type, id: id, ...data }, source: source, origin: origin }) {
        var result = handlers[type]?.(data);
        if (result instanceof Promise) result = await result;
        // @ts-ignore
        source.postMessage({
            ...result,
            id: id
        }, origin);
    }
    globalThis.addEventListener('message', server);
    return ()=>globalThis.removeEventListener('message', server);
}
function $cb57feaff75246de$export$9d97473344489dfc(target, origin = '*') {
    return (type, data)=>new Promise((resolve)=>{
            const UID = $cb57feaff75246de$export$89912e019eef22aa();
            function handler({ data: { id: id, ...data } }) {
                if (id !== UID) return;
                resolve(data);
                globalThis.removeEventListener('message', handler);
            }
            globalThis.addEventListener('message', handler);
            // @ts-ignore
            target.postMessage({
                id: UID,
                type: type,
                ...data
            }, origin);
        });
}
function $cb57feaff75246de$export$d635d04af3887bbe(registration) {
    return new Promise((resolve)=>{
        if (registration.waiting) return resolve(registration.waiting);
        registration.onupdatefound = ()=>registration.installing?.addEventListener('statechange', function() {
                if (this.state === 'installed' && navigator.serviceWorker.controller) resolve(this);
            });
    });
}
var $cb57feaff75246de$var$$7a08303ce13c49c5$exports = {};
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$7a08303ce13c49c5$exports, "PageVector", function() {
    return $cb57feaff75246de$export$1b88f6b6d432a52a;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$7a08303ce13c49c5$exports, "getSwipeVector", function() {
    return $cb57feaff75246de$export$b70f6380221b1350;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$7a08303ce13c49c5$exports, "durationOf", function() {
    return $cb57feaff75246de$export$75d6cbe4503e149;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$7a08303ce13c49c5$exports, "watchMotion", function() {
    return $cb57feaff75246de$export$b2618d51188815c2;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$7a08303ce13c49c5$exports, "transitIn", function() {
    return $cb57feaff75246de$export$490814474ddbb428;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$7a08303ce13c49c5$exports, "animateIn", function() {
    return $cb57feaff75246de$export$3ea201dffb50dfef;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$7a08303ce13c49c5$exports, "transitOut", function() {
    return $cb57feaff75246de$export$d1012c7198c6b460;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$7a08303ce13c49c5$exports, "animateOut", function() {
    return $cb57feaff75246de$export$a35a418b7b17958e;
});
class $cb57feaff75246de$export$1b88f6b6d432a52a {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
    get length() {
        const { from: from, to: to } = this;
        return Math.sqrt(Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2) + (to.z != null ? Math.pow(to.z - from.z, 2) : 0));
    }
    get direction() {
        const { from: from, to: to } = this;
        const XD = to.x - from.x, YD = to.y - from.y, ZD = to.z - from.z;
        const XL = Math.abs(XD), YL = Math.abs(YD), ZL = Math.abs(ZD);
        switch(isNaN(ZL) ? Math.max(XL, YL) : Math.max(XL, YL, ZL)){
            case XL:
                return XD > 0 ? 'right' : 'left';
            case YL:
                return YD > 0 ? 'forward' : 'backward';
            case ZL:
                return ZD > 0 ? 'up' : 'down';
        }
    }
}
function $cb57feaff75246de$export$b70f6380221b1350(from, to, threshold = parseInt(getComputedStyle(document.body).fontSize) * 6) {
    const vector = new $cb57feaff75246de$export$1b88f6b6d432a52a(from, to);
    if (vector.length >= threshold && !getSelection()?.toString().trim()) return vector;
}
function $cb57feaff75246de$export$75d6cbe4503e149(type, element) {
    const { transitionDuration: transitionDuration, animationDuration: animationDuration } = getComputedStyle(element);
    const duration = type === 'animation' ? animationDuration : transitionDuration;
    return parseFloat(duration) * (duration.slice(-2) === 'ms' ? 1 : 1000);
}
function $cb57feaff75246de$export$b2618d51188815c2(type, element) {
    return Promise.race([
        $cb57feaff75246de$export$1d1d2ed6b55cf67f(type, element).catch((event)=>Promise.resolve(event)),
        new Promise((resolve)=>setTimeout(resolve, $cb57feaff75246de$export$75d6cbe4503e149(type, element)))
    ]);
}
function $cb57feaff75246de$var$$7a08303ce13c49c5$var$fadeIn(type, element, className, display) {
    element.style.display = display;
    const end = $cb57feaff75246de$export$b2618d51188815c2(type, element);
    return new Promise((resolve)=>requestAnimationFrame(()=>{
            element.classList.add(className);
            end.then(resolve);
        }));
}
async function $cb57feaff75246de$var$$7a08303ce13c49c5$var$fadeOut(type, element, className, remove) {
    const end = $cb57feaff75246de$export$b2618d51188815c2(type, element);
    element.classList.remove(className);
    await end;
    if (remove) element.remove();
    else element.style.display = 'none';
}
function $cb57feaff75246de$export$490814474ddbb428(element, className, display = 'block') {
    return $cb57feaff75246de$var$$7a08303ce13c49c5$var$fadeIn('transition', element, className, display);
}
function $cb57feaff75246de$export$3ea201dffb50dfef(element, className, display = 'block') {
    return $cb57feaff75246de$var$$7a08303ce13c49c5$var$fadeIn('animation', element, className, display);
}
function $cb57feaff75246de$export$d1012c7198c6b460(element, className, remove) {
    return $cb57feaff75246de$var$$7a08303ce13c49c5$var$fadeOut('transition', element, className, remove);
}
function $cb57feaff75246de$export$a35a418b7b17958e(element, className, remove) {
    return $cb57feaff75246de$var$$7a08303ce13c49c5$var$fadeOut('animation', element, className, remove);
}
var $cb57feaff75246de$var$$69bd9f0117925302$exports = {};
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$69bd9f0117925302$exports, "describe", function() {
    return $cb57feaff75246de$export$cd5450f3a47e3789;
});
$cb57feaff75246de$var$$parcel$export($cb57feaff75246de$var$$69bd9f0117925302$exports, "it", function() {
    return $cb57feaff75246de$export$3486a10f30cf1ee4;
});
async function $cb57feaff75246de$export$cd5450f3a47e3789(title, cases) {
    console.log(title);
    console.time(title);
    await cases();
    console.timeEnd(title);
}
async function $cb57feaff75246de$export$3486a10f30cf1ee4(title, userCase, secondsOut = 3) {
    title = '    ' + title;
    console.time(title);
    const expect = (status)=>{
        const assert = typeof status === 'function' ? status : undefined;
        status = assert?.() ?? status;
        if (!status) throw new Error(`Assertion failed: ${title}\n\n${assert || ''}`);
    };
    const timeOut = ()=>$cb57feaff75246de$export$e772c8ff12451969(secondsOut).then(()=>Promise.reject(new RangeError('Timed out')));
    try {
        return await Promise.race([
            userCase(expect),
            timeOut()
        ]);
    } finally{
        console.timeEnd(title);
    }
}

});

parcelRegister("9V3mG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VNode = module.exports.VNodeMeta = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $14DK2 = parcelRequire("14DK2");

var $hsoqa = parcelRequire("hsoqa");
var $738c0c20a39726c4$var$VNodeMeta = /** @class */ function() {
    function VNodeMeta() {
        this.children = [];
    }
    return VNodeMeta;
}();
module.exports.VNodeMeta = $738c0c20a39726c4$var$VNodeMeta;
var $738c0c20a39726c4$var$VNode = /** @class */ function(_super) {
    $ceFTv.__extends(VNode, _super);
    function VNode(_b) {
        var e_1, _c, _d, e_2, _e;
        var _this = this;
        var children = _b.children, meta = $ceFTv.__rest(_b, [
            "children"
        ]);
        _this = _super.call(this) || this;
        _this.children = [];
        Object.assign(_this, meta);
        try {
            for(var _f = $ceFTv.__values(children || []), _g = _f.next(); !_g.done; _g = _f.next()){
                var vNode = _g.value;
                (_d = _this.children).push.apply(_d, $ceFTv.__spreadArray([], $ceFTv.__read(_a.isFragment(vNode) ? vNode.children || [] : [
                    vNode
                ]), false));
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        try {
            for(var _h = $ceFTv.__values(_this.children), _j = _h.next(); !_j.done; _j = _h.next()){
                var child = _j.value;
                child.parent = _this;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_j && !_j.done && (_e = _h.return)) _e.call(_h);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        var tagName = meta.tagName, is = meta.is, props = meta.props;
        if (!tagName && !(props === null || props === void 0 ? void 0 : props.className) && !is) return _this;
        _this.selector = [
            tagName === null || tagName === void 0 ? void 0 : tagName.toLowerCase(),
            (props === null || props === void 0 ? void 0 : props.className) && ".".concat(props.className.trim().replace(/\s+/, '.')),
            is && "[is=\"".concat(is, "\"]")
        ].filter(Boolean).join('');
        return _this;
    }
    VNode.prototype.walkUp = function() {
        var current;
        return $ceFTv.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    current = this;
                    _b.label = 1;
                case 1:
                    if (!(current = current.parent)) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        current
                    ];
                case 2:
                    _b.sent();
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    };
    VNode.prototype.namespaceOf = function(tagName) {
        var e_3, _b;
        if ($hsoqa.XMLNamespace[tagName]) return $hsoqa.XMLNamespace[tagName];
        try {
            for(var _c = $ceFTv.__values(this.walkUp()), _d = _c.next(); !_d.done; _d = _c.next()){
                var namespace = _d.value.namespace;
                if (namespace) return namespace;
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return $hsoqa.XMLNamespace.html;
    };
    VNode.prototype.createDOM = function(document1) {
        if (document1 === void 0) document1 = globalThis.document;
        var _b = this, tagName = _b.tagName, is = _b.is, text = _b.text;
        return this.node = text ? document1.createTextNode(text) : !tagName ? document1.createDocumentFragment() : document1.createElementNS(this.namespace || (this.namespace = this.namespaceOf(tagName)), tagName, {
            is: is
        });
    };
    VNode.prototype.toJSON = function() {
        var _b = this, key = _b.key, text = _b.text, selector = _b.selector, namespace = _b.namespace, tagName = _b.tagName, is = _b.is, props = _b.props, style = _b.style, children = _b.children;
        return JSON.parse(JSON.stringify({
            key: key,
            text: text,
            selector: selector,
            namespace: namespace,
            tagName: tagName,
            is: is,
            props: props,
            style: style,
            children: children
        }));
    };
    VNode.prototype.generateElementXML = function() {
        var _b, tagName, props, style, children, node, body, shadowRoots, innerHTML, restProps, _c, _d, _e, _i, key, _f, _g, _h, _j, key, children_1, children_1_1, child, e_4_1;
        var e_4, _k;
        return $ceFTv.__generator(this, function(_l) {
            switch(_l.label){
                case 0:
                    _b = this, tagName = _b.tagName, props = _b.props, style = _b.style, children = _b.children, node = _b.node;
                    if (!(tagName.includes('-') && (0, $hsoqa.elementTypeOf)(tagName) === 'html')) return [
                        3 /*break*/ ,
                        2
                    ];
                    body = ((node === null || node === void 0 ? void 0 : node.ownerDocument) || document).implementation.createHTMLDocument().body;
                    body.innerHTML = "<".concat(tagName, "></").concat(tagName, ">");
                    shadowRoots = $ceFTv.__spreadArray([], $ceFTv.__read((0, $14DK2.findShadowRoots)(body)), false);
                    return [
                        4 /*yield*/ ,
                        body.getHTML({
                            serializableShadowRoots: true,
                            shadowRoots: shadowRoots
                        })
                    ];
                case 1:
                    _l.sent();
                    return [
                        3 /*break*/ ,
                        29
                    ];
                case 2:
                    innerHTML = props.innerHTML, restProps = $ceFTv.__rest(props, [
                        "innerHTML"
                    ]);
                    return [
                        4 /*yield*/ ,
                        "<".concat(tagName)
                    ];
                case 3:
                    _l.sent();
                    _c = restProps;
                    _d = [];
                    for(_e in _c)_d.push(_e);
                    _i = 0;
                    _l.label = 4;
                case 4:
                    if (!(_i < _d.length)) return [
                        3 /*break*/ ,
                        7
                    ];
                    _e = _d[_i];
                    if (!(_e in _c)) return [
                        3 /*break*/ ,
                        6
                    ];
                    key = _e;
                    return [
                        4 /*yield*/ ,
                        " ".concat(_a.propsMap[key] || key, "=\"").concat(restProps[key], "\"")
                    ];
                case 5:
                    _l.sent();
                    _l.label = 6;
                case 6:
                    _i++;
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 7:
                    if (!style) return [
                        3 /*break*/ ,
                        14
                    ];
                    return [
                        4 /*yield*/ ,
                        " style=\""
                    ];
                case 8:
                    _l.sent();
                    _f = style;
                    _g = [];
                    for(_h in _f)_g.push(_h);
                    _j = 0;
                    _l.label = 9;
                case 9:
                    if (!(_j < _g.length)) return [
                        3 /*break*/ ,
                        12
                    ];
                    _h = _g[_j];
                    if (!(_h in _f)) return [
                        3 /*break*/ ,
                        11
                    ];
                    key = _h;
                    return [
                        4 /*yield*/ ,
                        "".concat((0, $hsoqa.toHyphenCase)(key), ":").concat(style[key], ";")
                    ];
                case 10:
                    _l.sent();
                    _l.label = 11;
                case 11:
                    _j++;
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 12:
                    return [
                        4 /*yield*/ ,
                        "\""
                    ];
                case 13:
                    _l.sent();
                    _l.label = 14;
                case 14:
                    if (!innerHTML) return [
                        3 /*break*/ ,
                        16
                    ];
                    return [
                        4 /*yield*/ ,
                        ">".concat(innerHTML, "</").concat(tagName, ">")
                    ];
                case 15:
                    _l.sent();
                    return [
                        3 /*break*/ ,
                        29
                    ];
                case 16:
                    if (!children[0]) return [
                        3 /*break*/ ,
                        27
                    ];
                    return [
                        4 /*yield*/ ,
                        '>'
                    ];
                case 17:
                    _l.sent();
                    _l.label = 18;
                case 18:
                    _l.trys.push([
                        18,
                        23,
                        24,
                        25
                    ]);
                    children_1 = $ceFTv.__values(children), children_1_1 = children_1.next();
                    _l.label = 19;
                case 19:
                    if (!!children_1_1.done) return [
                        3 /*break*/ ,
                        22
                    ];
                    child = children_1_1.value;
                    return [
                        5 /*yield**/ ,
                        $ceFTv.__values(child.generateXML())
                    ];
                case 20:
                    _l.sent();
                    _l.label = 21;
                case 21:
                    children_1_1 = children_1.next();
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 22:
                    return [
                        3 /*break*/ ,
                        25
                    ];
                case 23:
                    e_4_1 = _l.sent();
                    e_4 = {
                        error: e_4_1
                    };
                    return [
                        3 /*break*/ ,
                        25
                    ];
                case 24:
                    try {
                        if (children_1_1 && !children_1_1.done && (_k = children_1.return)) _k.call(children_1);
                    } finally{
                        if (e_4) throw e_4.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 25:
                    return [
                        4 /*yield*/ ,
                        "</".concat(tagName, ">")
                    ];
                case 26:
                    _l.sent();
                    return [
                        3 /*break*/ ,
                        29
                    ];
                case 27:
                    return [
                        4 /*yield*/ ,
                        tagName === 'script' ? '></script>' : ' />'
                    ];
                case 28:
                    _l.sent();
                    _l.label = 29;
                case 29:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    };
    VNode.prototype.generateXML = function() {
        var mode;
        return $ceFTv.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!_a.isFragment(this)) return [
                        3 /*break*/ ,
                        5
                    ];
                    return [
                        4 /*yield*/ ,
                        '<template'
                    ];
                case 1:
                    _b.sent();
                    mode = (this.node || {}).mode;
                    if (!mode) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        " shadowrootmode=\"".concat(mode, "\"")
                    ];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3:
                    return [
                        4 /*yield*/ ,
                        '>'
                    ];
                case 4:
                    _b.sent();
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 5:
                    if (!(this.text != null)) return [
                        3 /*break*/ ,
                        7
                    ];
                    return [
                        4 /*yield*/ ,
                        this.text
                    ];
                case 6:
                    _b.sent();
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 7:
                    return [
                        5 /*yield**/ ,
                        $ceFTv.__values(this.generateElementXML())
                    ];
                case 8:
                    _b.sent();
                    _b.label = 9;
                case 9:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    };
    VNode.isFragment = function(_b) {
        var key = _b.key, node = _b.node, children = _b.children, rest = $ceFTv.__rest(_b, [
            "key",
            "node",
            "children"
        ]);
        for(var key_1 in rest)if (!(0, $hsoqa.isEmpty)(rest[key_1])) return false;
        return true;
    };
    VNode.fromDOM = function(node) {
        var _this = this;
        if (node instanceof Text) return new _a({
            node: node,
            text: node.nodeValue
        });
        if (!(node instanceof Element)) return new _a({
            node: node
        });
        var _b = node, namespaceURI = _b.namespaceURI, tagName = _b.tagName, attributes = _b.attributes, style = _b.style, childNodes = _b.childNodes;
        var vNode = {
            node: node,
            namespace: namespaceURI,
            tagName: tagName.toLowerCase(),
            is: node.getAttribute('is')
        };
        var props = Array.from(attributes, function(_b) {
            var name = _b.name, value = _b.value;
            return name !== 'style' && [
                _this.attrsMap[name] || name,
                value
            ];
        }).filter(Boolean);
        if (props[0]) vNode.props = Object.fromEntries(props);
        var styles = Array.from(style, function(key) {
            return [
                key,
                style[key]
            ];
        });
        if (styles[0]) vNode.style = Object.fromEntries(styles);
        var children = Array.from(childNodes, function(node) {
            return _a.fromDOM(node);
        });
        if (children[0]) vNode.children = children;
        return new _a(vNode);
    };
    var _a;
    _a = VNode;
    VNode.propsMap = {
        httpEquiv: 'http-equiv',
        className: 'class',
        htmlFor: 'for'
    };
    VNode.attrsMap = Object.fromEntries(Object.entries(_a.propsMap).map(function(item) {
        return item.reverse();
    }));
    return VNode;
}($738c0c20a39726c4$var$VNodeMeta);
module.exports.VNode = $738c0c20a39726c4$var$VNode;

});
parcelRegister("14DK2", function(module, exports) {
var $0c84fe0555d1b36e$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $0c84fe0555d1b36e$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $0c84fe0555d1b36e$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $0c84fe0555d1b36e$var$__values = module.exports && module.exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
(function(factory) {
    if (typeof module.exports === "object") {
        var v = factory(undefined, module.exports);
        if (v !== undefined) module.exports = v;
    } else if (typeof define === "function" && define.amd) define([
        "require",
        "exports"
    ], factory);
})(function(require1, exports1) {
    "use strict";
    var _a, _b, _c, _d;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.findShadowRoots = findShadowRoots;
    exports1.generateHTML = generateHTML;
    exports1.getHTML = getHTML;
    exports1.attachDeclarativeShadowRoots = attachDeclarativeShadowRoots;
    exports1.setHTMLUnsafe = setHTMLUnsafe;
    exports1.parseHTMLUnsafe = parseHTMLUnsafe;
    var xmlSerializer = new XMLSerializer(), attachShadow = HTMLElement.prototype.attachShadow, shadowDOMs = new WeakMap();
    HTMLElement.prototype.attachShadow = function(options) {
        var shadowRoot = attachShadow.call(this, options);
        shadowDOMs.set(this, shadowRoot);
        return shadowRoot;
    };
    function findShadowRoots(root) {
        var walker, currentNode, shadowRoot;
        return $0c84fe0555d1b36e$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
                        acceptNode: function(node) {
                            return node instanceof HTMLElement ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
                        }
                    });
                    currentNode = null;
                    _a.label = 1;
                case 1:
                    if (!(currentNode = walker.nextNode())) return [
                        3 /*break*/ ,
                        5
                    ];
                    shadowRoot = shadowDOMs.get(currentNode);
                    if (!shadowRoot) return [
                        3 /*break*/ ,
                        4
                    ];
                    return [
                        4 /*yield*/ ,
                        shadowRoot
                    ];
                case 2:
                    _a.sent();
                    return [
                        5 /*yield**/ ,
                        $0c84fe0555d1b36e$var$__values(findShadowRoots(shadowRoot))
                    ];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    }
    function generateHTML(root, _a) {
        var walker, currentNode, tagName, attributes, shadowRoot, shadowRootHTML, nextSibling, parentElement;
        var _b = _a === void 0 ? {} : _a, serializableShadowRoots = _b.serializableShadowRoots, shadowRoots = _b.shadowRoots;
        return $0c84fe0555d1b36e$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    shadowRoots = (shadowRoots === null || shadowRoots === void 0 ? void 0 : shadowRoots.filter(Boolean)) || [];
                    if (!(!serializableShadowRoots || !shadowRoots[0])) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        root.innerHTML
                    ];
                case 1:
                    _c.sent();
                    return [
                        2 /*return*/ 
                    ];
                case 2:
                    walker = document.createTreeWalker(root, NodeFilter.SHOW_ALL, {
                        acceptNode: function(node) {
                            return node === root || node instanceof SVGElement ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
                        }
                    });
                    currentNode = null;
                    _c.label = 3;
                case 3:
                    if (!(currentNode = walker.nextNode())) return [
                        3 /*break*/ ,
                        19
                    ];
                    if (!(currentNode instanceof CDATASection)) return [
                        3 /*break*/ ,
                        5
                    ];
                    return [
                        4 /*yield*/ ,
                        "<![CDATA[".concat(currentNode.nodeValue, "]]>")
                    ];
                case 4:
                    _c.sent();
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 5:
                    if (!(currentNode instanceof Text)) return [
                        3 /*break*/ ,
                        7
                    ];
                    return [
                        4 /*yield*/ ,
                        currentNode.nodeValue || ""
                    ];
                case 6:
                    _c.sent();
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 7:
                    if (!(currentNode instanceof Comment)) return [
                        3 /*break*/ ,
                        9
                    ];
                    return [
                        4 /*yield*/ ,
                        "<!--".concat(currentNode.nodeValue, "-->")
                    ];
                case 8:
                    _c.sent();
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 9:
                    if (!(currentNode instanceof SVGElement)) return [
                        3 /*break*/ ,
                        11
                    ];
                    return [
                        4 /*yield*/ ,
                        xmlSerializer.serializeToString(currentNode)
                    ];
                case 10:
                    _c.sent();
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 11:
                    if (!(currentNode instanceof Element)) return [
                        3 /*break*/ ,
                        16
                    ];
                    tagName = currentNode.tagName.toLowerCase(), attributes = $0c84fe0555d1b36e$var$__spreadArray([], $0c84fe0555d1b36e$var$__read(currentNode.attributes), false).map(function(_a) {
                        var name = _a.name, value = _a.value;
                        return "".concat(name, "=").concat(JSON.parse(value));
                    }), shadowRoot = shadowDOMs.get(currentNode);
                    return [
                        4 /*yield*/ ,
                        "<".concat($0c84fe0555d1b36e$var$__spreadArray([
                            tagName
                        ], $0c84fe0555d1b36e$var$__read(attributes), false).join(" "), ">")
                    ];
                case 12:
                    _c.sent();
                    if (!(shadowRoot && shadowRoots.includes(shadowRoot))) return [
                        3 /*break*/ ,
                        14
                    ];
                    shadowRootHTML = $0c84fe0555d1b36e$var$__spreadArray([], $0c84fe0555d1b36e$var$__read(generateHTML(shadowRoot, {
                        serializableShadowRoots: serializableShadowRoots,
                        shadowRoots: shadowRoots
                    })), false).join("");
                    return [
                        4 /*yield*/ ,
                        "<template shadowrootmode=\"".concat(shadowRoot.mode, "\">").concat(shadowRootHTML, "</template>")
                    ];
                case 13:
                    _c.sent();
                    _c.label = 14;
                case 14:
                    if (!!currentNode.childNodes[0]) return [
                        3 /*break*/ ,
                        16
                    ];
                    return [
                        4 /*yield*/ ,
                        "</".concat(tagName, ">")
                    ];
                case 15:
                    _c.sent();
                    _c.label = 16;
                case 16:
                    nextSibling = currentNode.nextSibling, parentElement = currentNode.parentElement;
                    if (!(!nextSibling && parentElement && parentElement !== root)) return [
                        3 /*break*/ ,
                        18
                    ];
                    return [
                        4 /*yield*/ ,
                        "</".concat(parentElement.tagName.toLowerCase(), ">")
                    ];
                case 17:
                    _c.sent();
                    _c.label = 18;
                case 18:
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 19:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    }
    /**
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Element/getHTML}
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ShadowRoot/getHTML}
     */ function getHTML(options) {
        if (options === void 0) options = {};
        return $0c84fe0555d1b36e$var$__spreadArray([], $0c84fe0555d1b36e$var$__read(generateHTML(this, options)), false).join("");
    }
    function attachDeclarativeShadowRoots(root) {
        var e_1, _a;
        var templates = root.querySelectorAll("template[shadowrootmode]");
        try {
            for(var templates_1 = $0c84fe0555d1b36e$var$__values(templates), templates_1_1 = templates_1.next(); !templates_1_1.done; templates_1_1 = templates_1.next()){
                var template = templates_1_1.value;
                var parentElement = template.parentElement, content = template.content;
                var shadowRoot = parentElement.attachShadow({
                    mode: template.getAttribute("shadowrootmode")
                });
                shadowRoot.append(content);
                template.remove();
                attachDeclarativeShadowRoots(shadowRoot);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (templates_1_1 && !templates_1_1.done && (_a = templates_1.return)) _a.call(templates_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    }
    /**
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Element/setHTMLUnsafe}
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ShadowRoot/setHTMLUnsafe}
     */ function setHTMLUnsafe(html) {
        this.innerHTML = html;
        attachDeclarativeShadowRoots(this);
    }
    var domParser = new DOMParser(), initDocument = function(_a) {
        var _b = _a === void 0 ? document : _a, documentElement = _b.documentElement;
        return attachDeclarativeShadowRoots(documentElement);
    };
    /**
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Document/parseHTMLUnsafe_static}
     */ function parseHTMLUnsafe(html) {
        var document1 = domParser.parseFromString(html, "text/html");
        initDocument(document1);
        return document1;
    }
    (_a = Element.prototype).getHTML || (_a.getHTML = getHTML);
    (_b = Element.prototype).setHTMLUnsafe || (_b.setHTMLUnsafe = setHTMLUnsafe);
    (_c = ShadowRoot.prototype).getHTML || (_c.getHTML = getHTML);
    (_d = ShadowRoot.prototype).setHTMLUnsafe || (_d.setHTMLUnsafe = setHTMLUnsafe);
    Document.parseHTMLUnsafe || (Document.parseHTMLUnsafe = parseHTMLUnsafe);
    new Promise(function(resolve) {
        if (document.readyState === "complete") resolve();
        else {
            document.addEventListener("DOMContentLoaded", resolve);
            window.addEventListener("load", resolve);
        }
    }).then(function() {
        return initDocument();
    });
});

});




//# sourceMappingURL=dynamic.968b43fe.js.map
